export default {
    namespaced: true,
    state: {
        errorRequest: false,
        showPopup: false,
        mainLoading: true,
        drawer: true,
        commonDataLoaded: false
    }, // = data
    getters: {
        getDrawerTogged(state) {
            return state.drawer;
        }
    }, // = computed
    mutations: {
        setStateShowModal(state, status) {
            state.showPopup = status;
        },
        setStateErrorRequest(state) {
            state.errorRequest = true;
        },
        setMainLoading(state, status) {
            state.mainLoading = status;
        },
        setDrawerTogged(state) {
            state.drawer = !state.drawer;
        },
        setCommonDataLoaded(state) {
            state.commonDataLoaded = true;
        }
    }, // change state here
    actions: {
        setStateShowModal({commit}, status) {
          commit("setStateShowModal", status)
        },
        setStateErrorRequest({ commit }) {
            commit("setStateErrorRequest");
        },
        setStateTokenExpired({ commit }) {
            commit("auth/logout", null, {
                root: true
            });
            commit("setCommonDataLoaded");
            // commit("setStateErrorRequest");
        },
        setDrawerTogged({ commit }) {
            commit("setDrawerTogged");
        },
        setMainLoading({ commit }, status) {
            commit("setMainLoading", status);
        },
        setCommonDataLoaded({ commit }) {
            commit("setCommonDataLoaded");
        }
    } // = method active mutations
};
